import * as React from "react";
import PropTypes from "prop-types";
import {
  Box,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Grid
} from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import CircleIcon from "@mui/icons-material/Circle";
import CheckIcon from "@mui/icons-material/Check";
import DialButton from "../../Buttons/DialButton/DialButton";
import StyledTooltip from "../../StyledTooltip/StyledTooltip";
import { nullCheck } from "../../../utils/dataHelpers";

export default function SidebarNetworkItem({ carrier, index, handleBookmark, handleNewInteraction, handleTableAction, isRecentlyItem }) {
  const phoneNumber = nullCheck(carrier, null, "phoneNumber");
  const days = carrier.pipelineStatus === "LEAD" ? carrier.activityExpireDays : carrier.loadsExpireDays;
  const showDays = days != null && days != undefined && (days < 3 && carrier.pipelineStatus === "LEAD" || days < 10 && carrier.pipelineStatus === "RELATN");

  return (
    <ListItem>
      <ListItemIcon>
        <Box sx={{ marginLeft: "12px" }}>
          <DialButton
            number={phoneNumber}
            icon="phone"
            disabled={!phoneNumber}
            color="white"
          />
        </Box>
      </ListItemIcon>
      <ListItemText>
        <Grid container direction="row" alignItems="center" spacing={2}>
          <Grid item xs={8}>
            <Typography
              variant="body2"
              sx={{
                color: "black_solid.50",
                cursor: "pointer"
              }}
              onClick={() => handleTableAction({ action: "carrier-profile", carrierId: carrier.carrierId })}
            >
              {carrier.name?.toUpperCase()}
            </Typography>
          </Grid>
          {!isRecentlyItem && (
            <Grid item xs={2}>
              {showDays &&
                <StyledTooltip title={`${days} ${days === 1 ? "day" : "days"} left`}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "black_solid.50",
                      color: "black_solid.80",
                      fontSize: "10px",
                      height: "15px",
                      width: "15px",
                      borderRadius: 5
                    }}>{days}</Box>
                </StyledTooltip>
              }
            </Grid>
          )}
          {!isRecentlyItem && (
            <Grid item xs={2}>
              {carrier.checkMark ?
                <CheckIcon sx={{ fontSize: "17px", color: "success.60" }} />
                : carrier.isNew &&
                <CircleIcon
                  onClick={() => handleNewInteraction(index, carrier)}
                  sx={{ fontSize: "10px", color: "success.60", cursor: "pointer" }}
                />
              }
            </Grid>
          )}
          {isRecentlyItem && (
            <>
              <Grid item xs={2}></Grid>
              <Grid item xs={2}>
                {carrier.isBookmark ?
                  (
                    <BookmarkIcon
                      onClick={() => handleBookmark(index, carrier)}
                      sx={{ fontSize: "15px", color: "black_solid.50", cursor: "pointer" }}
                    />
                  ) : (
                    <BookmarkBorderIcon
                      onClick={() => handleBookmark(index, carrier)}
                      sx={{ fontSize: "15px", color: "black_solid.50", cursor: "pointer" }}
                    />
                  )}
              </Grid>
            </>
          )}
        </Grid>
      </ListItemText>
    </ListItem>
  );
}

SidebarNetworkItem.propTypes = {
  carrier: PropTypes.object.isRequired,
  index: PropTypes.number,
  handleBookmark: PropTypes.func,
  handleNewInteraction: PropTypes.func,
  handleTableAction: PropTypes.func,
  isRecentlyItem: PropTypes.bool
};